import { render, staticRenderFns } from "./noteCom.vue?vue&type=template&id=2ac1ce1e&"
import script from "./noteCom.vue?vue&type=script&lang=js&"
export * from "./noteCom.vue?vue&type=script&lang=js&"
import style0 from "./noteCom.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports